import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import DynamicPricing from './pages/DynamicPricing';
import GoogleShopping from './pages/GoogleShopping';
import MarketplaceMonitoring from './pages/MarketplaceMonitoring';
import CompetitorMonitoring from './pages/CompetitorMonitoring';
import MapAlerts from './pages/MapAlerts';
import Resources from './pages/Resources';
import BlogPost from './pages/BlogPost';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Trial from './pages/Trial';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ColorPicker from './pages/ColorPicker';
import Admin from './pages/Admin';
import Unsubscribe from './pages/Unsubscribe';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dynamic-pricing" element={<DynamicPricing />} />
            <Route path="/google-shopping" element={<GoogleShopping />} />
            <Route path="/marketplace-monitoring" element={<MarketplaceMonitoring />} />
            <Route path="/competitor-monitoring" element={<CompetitorMonitoring />} />
            <Route path="/map-alerts" element={<MapAlerts />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/help/:slug" element={<BlogPost />} />
            <Route path="/updates/:slug" element={<BlogPost />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/trial" element={<Trial />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/colors" element={<ColorPicker />} />
            <Route path="/sapadmin" element={<Admin />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;